<!-- Monthly Statement -->
<terra-unit-bank-account-statement
  [statements]="bankAccount.statements"
  [unitBankAccountId]="bankAccount.unitResourceId">
</terra-unit-bank-account-statement>

<terra-unit-bank-account-verification-letter></terra-unit-bank-account-verification-letter>
